import I18n from 'I18n';
import LinkWrapper from '../common/LinkWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CrossedOutPrice, PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RequiredOnboardingSubtextContentLegacy = ({
  langKey,
  currencyCode,
  fullPrice,
  calculatedPrice,
  onboardingIncludedKey,
  handleClick,
  onboardingServicesUrl
}) => {
  const BringAttention = styled.b.withConfig({
    displayName: "constRequiredOnboardingSubtextContentLegacy__BringAttention",
    componentId: "b7ji3r-0"
  })([""]);
  return /*#__PURE__*/_jsxs(Small, {
    children: [fullPrice && calculatedPrice && fullPrice > calculatedPrice ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}-with-discount_jsx`,
      options: {
        currencyCode,
        fullPrice,
        discountedPrice: calculatedPrice
      },
      elements: {
        PriceDisplay,
        CrossedOutPrice,
        b: BringAttention
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}_jsx`,
      options: {
        currencyCode,
        price: calculatedPrice
      },
      elements: {
        PriceDisplay,
        b: BringAttention
      }
    }), ' ', /*#__PURE__*/_jsx(LinkWrapper, {
      external: true,
      onClick: handleClick,
      href: onboardingServicesUrl,
      "aria-label": I18n.text(`planBuilder.requiredOnboardingSubtext.onboarding.${langKey}`),
      iconProps: {
        size: '100'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.learnMore"
      })
    })]
  });
};